import { cookieRegistry } from './cookieRegistry.js';

/**
 * PositionNormalizer - converts live WebSocket positions to the replay-compatible
 * format that ReplayManager expects.
 *
 * WebSocket format:                Replay format:
 *   alt_m (sometimes)               altitude_m
 *   aircraft                        aircraft_type
 *   cookie (numeric)                cookie (canonical pilot_*)
 *   lat/lon (numbers)               lat/lon (numbers)
 *   timestamp (ISO string)          timestamp (Date object)
 */

/**
 * Normalize a single live WebSocket position to replay format.
 * Mutates nothing — returns a new object.
 *
 * @param {Object} pos - raw WebSocket position
 * @returns {Object} replay-compatible position
 */
export function normalizePosition(pos) {
  const callsign = pos.id_cn || pos.callsign;
  const canonicalCookie = (pos.cookie && callsign)
    ? cookieRegistry.registerLive(pos.cookie, callsign)
    : (pos.cookie ? cookieRegistry.resolve(pos.cookie) : null);

  return {
    lat: parseFloat(pos.lat ?? pos.latitude) || 0,
    lon: parseFloat(pos.lon ?? pos.longitude) || 0,
    timestamp: pos.timestamp instanceof Date
      ? pos.timestamp
      : new Date(pos.timestamp),
    cookie: canonicalCookie || pos.cookie,
    callsign: callsign || '',
    id_cn: callsign || '',
    aircraft_type: pos.aircraft_type || pos.aircraft || pos.id_model || null,
    serverName: pos.serverName || '',
    portNumber: pos.portNumber || '',
    altitude_m: parseFloat(pos.altitude_m ?? pos.alt_m) || 0,
    speed_mps: parseFloat(pos.speed_mps) || 0,
    vario_mps: parseFloat(pos.vario_mps) || 0,
    heading_deg: parseFloat(pos.heading_deg) || 0,
    altitude_agl_m: pos.altitude_agl_m != null ? parseFloat(pos.altitude_agl_m) : undefined,
    pitch_deg: pos.pitch_deg != null ? parseFloat(pos.pitch_deg) : undefined,
    roll_deg: pos.roll_deg != null ? parseFloat(pos.roll_deg) : undefined,
    yaw_deg: pos.yaw_deg != null ? parseFloat(pos.yaw_deg) : undefined,
    id_fname: pos.id_fname || '',
    id_lname: pos.id_lname || '',
  };
}
